import {
  markBuilderStateDirty
} from "./chunk-UEG4HCRI.js";

// src/persisted-state.ts
var EXXAT_STORAGE_PREFIX = "exxat-ds:";
var DEFAULT_DEBOUNCE_MS = 400;
var debounceTimers = /* @__PURE__ */ new Map();
function isBrowser() {
  return typeof window !== "undefined";
}
function getDriverImpl(driver) {
  if (!isBrowser()) return null;
  try {
    return driver === "session" ? window.sessionStorage : window.localStorage;
  } catch {
    return null;
  }
}
function namespacedKey(key) {
  return key.startsWith(EXXAT_STORAGE_PREFIX) ? key : `${EXXAT_STORAGE_PREFIX}${key}`;
}
function getStorageItem(key, driver = "local") {
  const store = getDriverImpl(driver);
  if (!store) return null;
  try {
    return store.getItem(namespacedKey(key));
  } catch {
    return null;
  }
}
function setStorageItem(key, value, driver = "local") {
  const store = getDriverImpl(driver);
  if (!store) return;
  try {
    const fullKey = namespacedKey(key);
    if (store.getItem(fullKey) === value) return;
    store.setItem(fullKey, value);
    markBuilderStateDirty();
  } catch {
  }
}
function scheduleStorageWrite(key, value, options = {}) {
  if (!isBrowser()) return;
  const { debounceMs = DEFAULT_DEBOUNCE_MS, driver = "local" } = options;
  const fullKey = namespacedKey(key);
  const prev = debounceTimers.get(fullKey);
  if (prev) clearTimeout(prev);
  const timer = setTimeout(() => {
    debounceTimers.delete(fullKey);
    setStorageItem(key, value, driver);
  }, debounceMs);
  debounceTimers.set(fullKey, timer);
}

export {
  EXXAT_STORAGE_PREFIX,
  DEFAULT_DEBOUNCE_MS,
  namespacedKey,
  getStorageItem,
  setStorageItem,
  scheduleStorageWrite
};
